import { FC, PropsWithChildren } from 'react';

const AspspPageContent: FC<PropsWithChildren> = ({ children }) => (
  <>{children}</>
);

export default AspspPageContent;
